import { createApp, ref, computed, watch, onMounted } from 'vue';
import axios from 'axios';

const propertiesList = () => {
	const list = document.querySelector('.properties-list');
	if (!list) {
		return;
	}

	const app = createApp({
		delimiters: ['${', '}'],
		setup() {
			const showSpinner = ref(1);
			const total = ref(0);
			const properties = ref([]);
			const page = ref(1);
			const numberOfPages = ref(0);
			const perPage = ref(9);
			const pages = ref([]);

			const getProperties = async () => {
				try {
					const response = await axios.get('/api/properties.json');
					properties.value = response.data.data;
				} catch (error) {
					console.error('Error fetching properties:', error);
				}
			};

			const resetPage = () => {
				page.value = 1;
			};

			const setNumberOfPages = (length) => {
				numberOfPages.value = Math.ceil(length / perPage.value);
			};

			const setPages = () => {
				showSpinner.value = 0;
				setNumberOfPages(properties.value.length);
				pages.value = [];
				for (let index = 1; index <= numberOfPages.value; index += 1) {
					pages.value.push(index);
				}
			};

			const paginate = (propertiesToPaginate) => {
				total.value = propertiesToPaginate.length;
				setNumberOfPages(total.value);
				const from = (page.value - 1) * perPage.value;
				const to = page.value * perPage.value;
				return propertiesToPaginate.slice(from, to);
			};

			const displayedProperties = computed(() => {
				return paginate(properties.value);
			});

			watch(properties, () => {
				setPages();
			});

			onMounted(() => {
				getProperties();
			});

			return {
				showSpinner,
				total,
				properties,
				page,
				numberOfPages,
				perPage,
				pages,
				displayedProperties,
				resetPage,
				getProperties
			};
		}
	});

	app.mount(list);
};

export default propertiesList;
